import axios from 'axios'
import Vue from 'vue'
import Cache from '@/utils/cache.js'
import store from '@/store'
import router from '@/router'

function getUuid() {
    if (typeof crypto === 'object' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    } else {
        // 回退到兼容实现
        return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    }
}
const uuid = getUuid();
// 创建axios实例
const service = axios.create({
  baseURL: '/mallapi/', // 从环境变量读取
  timeout: 15000 // 请求超时时间
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    // 示例：添加token
    const token = Cache.get('accessToken') || ''
    // if (token) {
      config.headers['Authorization'] = `${token}`
    // }
    config.headers['uuid'] = localStorage.getItem('uuid') || uuid
    return config
  },
  error => {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    // console.log(response, 'response')
    let resData = response.data
    // 智能问答由调用方处理业务状态，保留 409/429 等状态且不输出模型正文。
    // 只对 operationGuide 的显式标记生效，其他接口继续沿用原流程。
    if (response.config && response.config.operationGuideAi === true) return Promise.resolve(resData)
    //如果是403，则清空登录信息
    if (resData.resultCode === '403') {
      console.log('如果是403，则清空登录信息')
      Vue.prototype.$message.error(resData.resultMsg)
      let jumpLoginNum = Cache.get('jumpLoginNum')
        ? JSON.parse(Cache.get('jumpLoginNum'))
        : 0
      let temp = jumpLoginNum + 1
      Cache.set('jumpLoginNum', temp)
      setTimeout(() => {
        store.dispatch('userOutLogin').then(() => {
          router.push('/public/service/login').catch(err => {
            // 忽略 NavigationDuplicated 错误
            if (err.name !== 'NavigationDuplicated') {
              console.error(err)
            }
          })
        })
      }, 1000)
      return Promise.resolve(resData)
    }
    // 报名流程须保留 400/409 原因，由页面保留草稿并引导重新报价。
    // 上方认证失效流程不变，其他业务请求仍沿用原行为。
    if (response.config && response.config.registrationRequest === true) return Promise.resolve(resData)
    if (resData.resultCode !== '200') {
      Vue.prototype.$message.error(resData.resultMsg)
      return Promise.resolve(resData.resultCode)
    } else {
      return Promise.resolve(resData)
    }
  },
  (error) => {
    if (error.config && error.config.registrationRequest === true) {
      const data = error.response && error.response.data
      return Promise.reject({ resultCode: String(data && data.resultCode || error.response && error.response.status || 'NETWORK_ERROR'),
        resultMsg: data && data.resultMsg || '报名服务连接失败，请重试' })
    }
    if (error.config && error.config.operationGuideAi === true) {
      const data = error.response && error.response.data
      const safeError = new Error('操作指引智能服务请求失败')
      safeError.code = String(data && data.resultCode || error.response && error.response.status || error.code || '')
      // 不保留包含认证头、问题原文和模型响应的 Axios error/config。
      return Promise.reject(safeError)
    }
    console.log(error, 'error')
    let errorInfo = error.data && error.data.error ? error.data.error.message : error.data
    return Promise.reject(errorInfo)
  }
)

export default service
